<template>
    <div class="btn flex flex-align-center" @click="$emit('click')">
        <div class="txt"><slot>返回列表</slot></div>
        <i class="fa fa-arrow-right"></i>
    </div>
</template>

<script>
export default {
  
}
</script>

<style scoped>
.btn{
  padding: 12px 20px;
  border: 1px solid #004b94;
  color: #004b94;
  font-size: 16px;
  width: 266px;
  margin: 60px auto 0;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: .3s;
  justify-content: center;
  z-index: 99;
}
.btn::before{
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background-color: #004b94;
    transition: .3s;
    border-radius: 0 50px 50px 0;
    border-right: 50px solid #004b94;
    margin-left: -50px;
    z-index: -1;
}
.btn:hover::before{
    left: 0;
    margin-left: 0;
}
.btn:hover{
  color: #fff;
}
.btn .txt{
  margin-right: 50px;
}
</style>


